import template from './environment_config.edit.html';
import controller from './environment_config.edit.controller';
import './environment_config.edit.scss';

const environmentConfigEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default environmentConfigEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/environment_config/edit/environment_config.edit.component.js